/**
 * 🎯 Shared hook for modal/drawer container management
 * Replaces duplicate mounted state and portal logic across Cart and CreationFlow
 */

import { useState, useEffect } from 'react'

export function useModalContainer() {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return { mounted }
}

